import { createApp } from 'vue/dist/vue.esm-bundler.js';

function mapSearchResponseToItem(item, queryRegex) {
  const title = item['_source']['orthomolcorporaterecipe.title'];
  return {
    id: item['_id'],
    title: title,
    htmlTitle: queryRegex ? title.replace(queryRegex, '<mark>$&</mark>') : title,
    url: window.location.href.includes('/de-at/')
      ? item['_source']['uri'].replace('/de-de/', '/de-at/')
      : item['_source']['uri'],
    keyvisual: item['_source']['orthomolcorporaterecipe.teaserImage'],
    amountStars: item['_source']['orthomolcorporaterecipe.amountStars'],
    rating: item['_source']['orthomolcorporaterecipe.ratingAverage'],
    preparationTime: item['_source']['orthomolcorporaterecipe.preparationTime.raw'],
    diets: item['_source']['orthomolcorporaterecipe.diet'],
  };
}

const RecipeOverviewApp = {
  data() {
    return {
      filters: [],
      results: [],
      typeaheadFilter: ['Zutaten'],
      activeFilters: [],
      notActiveFilters: [],
      facetTypes: {
        Schwierigkeitsgrad: 'facet-difficulty',
        Zeitaufwand: 'facet-recipepreparation',
        Kategorie: 'facet-category',
        Zutaten: 'facet-ingredients',
        Nährstoffe: 'facet-nutrients',
        Ernährungsweise: 'facet-diet',
        Anwendungsgebiet: 'facet-lifeworld',
      },
      currentPage: 1, // Pages start with 1
      pageSize: 15,
      query: '',
      isLoading: true,
    };
  },
  async created() {
    window.addEventListener('hashchange', this.handleHashChange);
    // initial request to load all filters
    const response = await fetch('/de-de/search/rezepte');
    const data = await response.json();
    this.filters = data.filter;
    let that = this;
    //apply filter from url-hash
    const hashFilter = window.location.hash
      .substring(1)
      .split('&')
      .map((x) => x.split('='))
      .filter((x) => x.length > 1)
      .map((x) => {
        if (x[0] === 'q') {
          that.query = decodeURIComponent(x[1]);
          return null;
        }
        return { formName: x[0], name: decodeURIComponent(x[1]) };
      })
      .filter((x) => x !== null);
    let filterValues = [];
    this.filters.forEach((filter) => filter.values.forEach((val) => filterValues.push(val)));
    hashFilter.forEach((filter) => {
      const curFilter = filterValues.filter((x) => x.name === filter.name)[0];
      if (curFilter == null) {
        return;
      }
      curFilter.active = true;
      this.activeFilters.push(curFilter);
    });
    // load filtered recipes
    this.update();
  },
  methods: {
    handleHashChange(event) {
      let url = window.location.href;
      let that = this;
      //add filter from url-hash
      this.checkFilterFromHashUrl(url, that);
      // load filtered recipes
      this.updateRecipes();

      if (window.location.hash === '') {
        // Prevent the default jump to the top
        event.preventDefault();
        return false;
      }
    },
    checkFilterFromHashUrl(url) {
      //apply filter from url-hash
      const hashFilter = url
        .split('#')
        .pop()
        .split('&')
        .map((x) => x.split('='));
      let filterValues = [];
      hashFilter.forEach((val) => filterValues.push(val));
      let queryHashFilter = hashFilter.filter((x) => x[0] == 'q');
      if (queryHashFilter.length == 0) {
        this.query = '';
      } else {
        this.query = decodeURI(queryHashFilter[0][1]);
      }

      //put all used filters to check in active filters
      this.notActiveFilters.forEach((item) => this.activeFilters.push(item));
      this.activeFilters.forEach((x) => {
        let check = false;
        hashFilter.forEach((val) => {
          const hashVal = decodeURIComponent(val[1]);
          const prevActiveFilter = decodeURIComponent(x.value);
          if (hashVal === prevActiveFilter) {
            check = true;
          }
        });
        if (check === false) {
          x.active = false;
        } else {
          x.active = true;
        }
      });
      this.notActiveFilters = this.activeFilters.filter((x) => x.active === false);
      this.activeFilters = this.activeFilters.filter((x) => x.active !== false);
    },
    updateHash() {
      let hashValues = [];
      this.activeFilters.forEach((item) => hashValues.push(`${item['form_name']}=${encodeURIComponent(item['name'])}`));
      if (this.query.length > 0) {
        hashValues.push(`q=${encodeURIComponent(this.query)}`);
      }
      let hashFilter = '#' + hashValues.join('&');
      window.location = hashFilter;
    },
    filterAdded(filter) {
      if (this.activeFilters.indexOf(filter) !== -1) {
        return;
      }
      this.activeFilters.push(filter);
      this.update();
    },
    filterRemoved(filter) {
      this.activeFilters = this.activeFilters.filter((x) => x != filter);
      this.update();
    },
    async update() {
      await this.updateRecipes();
      this.updateHash();
    },
    async updateRecipes() {
      this.isLoading = true;
      this.currentPage = 1;
      const filter = this.activeFilters.map((x) => [x.form_name, x.value]);
      if (this.query.length > 1) {
        filter.push(['q', this.query]);
      }
      const query = new URLSearchParams(filter).toString();
      const response = await fetch('/de-de/search/rezepte?' + query, {
        method: 'GET',
      });
      const data = await response.json();
      this.isLoading = false;
      this.filters = data.filter;
      this.results = data.result;
    },
    getFacetType(filterLabel) {
      return this.facetTypes[filterLabel];
    },
    async loadMore() {
      this.currentPage += 1;
      let filter = this.activeFilters.map((x) => [x.form_name, x.value]);
      filter.push(['page', this.currentPage]);
      const query = new URLSearchParams(filter).toString();
      const response = await fetch('/de-de/search/rezepte?' + query, {
        method: 'GET',
      });
      const data = await response.json();
      this.results = this.results.concat(data.result);
    },
    resetFilters() {
      this.activeFilters = [];
      this.filters = this.filters.forEach((x) => (x.active = false));
      this.query = '';
      this.updateHash();
      this.updateRecipes();
    },
    setQueryFilter(query) {
      this.query = query;
      this.update();
    },
  },
  computed: {
    recipes() {
      const queryRegex = this.query ? new RegExp(this.query, 'gi') : null;
      return this.results.map((result) => mapSearchResponseToItem(result, queryRegex));
    },
    isNextPageAvailable() {
      return this.results.length % this.pageSize === 0;
    },
    hasRecipes() {
      return this.results.length !== 0;
    },
  },
};

const app = createApp(RecipeOverviewApp);

app.component('checkbox-filter', {
  props: ['title', 'items', 'facettype'],
  emits: ['filterAdded', 'filterRemoved'],
  template: '#checkbox-filter',
  data() {
    let items = this.$props.items ?? [];
    let sorted = [];
    items.forEach((item) => {
      if (sorted.length === 0) {
        sorted.push(item);
        return;
      }
      let amount = sorted.length;
      let pos = 0;
      for (let i = 0; i < amount; i++) {
        pos = i;
        let curSortedElement = sorted[i];
        let res = item.name.localeCompare(curSortedElement.name);
        if (res === -1 || 0) {
          break;
        } else if (pos + 1 >= amount) {
          pos++;
          break;
        }
      }
      sorted.splice(pos, 0, item);
    });
    items = sorted;
    return {
      amountFilterElements: 6,
      items: items,
      expanded: false,
      translations: {
        Laktosefrei: 'lactosefree',
        Vegetarisch: 'vegetarian',
        Vegan: 'vegan',
      },
    };
  },
  created() {},
  methods: {
    clearFilter() {
      this.$data.items.forEach((val) => (val.active = false));
    },
    expand() {
      this.expanded = true;
    },
    shrink() {
      this.expanded = false;
    },
    toggle(item) {
      if (item.active === true) {
        this.$emit('filterAdded', item);
      } else {
        this.$emit('filterRemoved', item);
      }
    },
    classFacetValue(item) {
      return {
        'facet-value': true,
        'active-facet': item.active,
      };
    },
    translate(val) {
      let translated = this.translations[val];
      return translated ?? val;
    },
  },
  computed: {
    visibleElements() {
      if (this.expanded === false) {
        return this.$data.items.slice(0, this.amountFilterElements);
      }
      return this.$data.items;
    },
    moreThanMaxElementsAvailable() {
      return this.$data.items.length > this.amountFilterElements;
    },
  },
});
app.component('typeahead-badge-filter', {
  props: ['title', 'items'],
  template: '#typeahead-badge-filter',
  emits: ['filterAdded', 'filterRemoved'],
  data() {
    return {
      currentActiveIndex: -1,
      query: '',
      showSuggestions: false,
      suggestions: [],
      minChars: 2,
      items: this.$props.items ?? [],
      activeItems: (this.$props.items ?? []).filter((x) => x.active === true),
      limit: 6,
    };
  },
  methods: {
    clearFilter() {
      this.activeItems = [];
      this.reset();
    },
    activeClass(index) {
      return {
        active: this.currentActiveIndex === index,
      };
    },
    addBadge(item) {
      // only add each item max 1 time
      if (this.activeItems.indexOf(item) !== -1) {
        return;
      }
      this.activeItems.push(item);
      this.query = '';
      this.suggestions = [];
      this.$emit('filterAdded', item);
    },
    addBadgeCurrent() {
      let item = this.suggestions[this.currentActiveIndex];
      if (item == null) {
        return;
      }
      this.addBadge(item);
    },
    setActive(index) {
      this.currentActiveIndex = index;
    },
    down() {
      this.currentActiveIndex++;
      if (this.currentActiveIndex >= this.suggestions.length) {
        this.currentActiveIndex = 0;
      }
    },
    up() {
      this.currentActiveIndex--;
      if (this.currentActiveIndex < 0) {
        this.currentActiveIndex = this.suggestions.length - 1;
      }
    },
    reset() {
      this.currentActiveIndex = -1;
      this.showSuggestions = false;
    },
    update() {
      if (this.query.length < this.minChars) {
        this.suggestions = [];
        return;
      }

      /** @type {RegExp} */
      const regex = this.regex;
      this.suggestions = this.$data.items
        .map((item) => {
          /** @type {string} */
          let itemName = item.name;
          const matches = regex.exec(itemName);
          if (matches == null || matches.length == 0) {
            return null;
          }
          matches.forEach(
            /** @type {string} */ (match) => {
              const index = itemName.indexOf(match);
              const start = itemName.slice(0, index);
              let searched = itemName.slice(index, index + match.length);
              searched = `<mark>${searched}</mark>`;
              let end = itemName.slice(index + match.length);
              itemName = start.concat(searched, end);
            }
          );
          return { ...item, label: itemName };
        })
        .filter((x) => x !== null)
        .slice(0, this.limit);
      this.showSuggestions = this.suggestions.length > 0;
    },
    removeBadge(item) {
      this.activeItems = this.activeItems.filter((x) => x.name !== item.name);
      this.$emit('filterRemoved', item);
    },
    toggleShowSuggestions(isVisible) {
      this.showSuggestions = isVisible;
    },
  },
  computed: {
    regex() {
      let regex = new RegExp(this.$data.query, 'ig');
      return regex;
    },
  },
});

app.component('typeahead-searchbox', {
  template: '#typeahead-searchbox',
  props: ['filter', 'initialQuery'],
  emits: ['query-set'],
  data() {
    return {
      currentActiveIndex: -1,
      query: this.$props.initialQuery ?? '',
      lastInitialQuery: this.$props.initialQuery ?? '',
      showSuggestions: false,
      suggestions: [],
      minChars: 2,
      items: [],
      limit: 6,
      timeout: null,
    };
  },
  updated() {
    if (this.lastInitialQuery != this.$props.initialQuery) {
      this.query = this.$props.initialQuery;
      this.lastInitialQuery = this.query;
    }
  },
  methods: {
    clearFilter() {
      this.reset();
    },
    activeClass(index) {
      return {
        active: this.currentActiveIndex === index,
      };
    },
    ariaSelected(index) {
      return this.currentActiveIndex === index ? 'true' : '';
    },
    setActive(index) {
      this.currentActiveIndex = index;
    },
    down() {
      if (!this.showSuggestions) {
        return;
      }

      this.currentActiveIndex++;
      if (this.currentActiveIndex >= this.items.length) {
        this.currentActiveIndex = 0;
      }
      this.query = this.items[this.currentActiveIndex].title;
    },
    /**
     * @param {KeyboardEvent} e
     */
    up(e) {
      if (!this.showSuggestions) {
        return;
      }
      this.currentActiveIndex--;
      if (this.currentActiveIndex < 0) {
        this.currentActiveIndex = this.items.length - 1;
      }
      this.query = this.items[this.currentActiveIndex].title;
    },
    /**
     * @param {KeyboardEvent} e
     */
    home(e) {
      e.stopPropagation();
      e.preventDefault();
      e.target.setSelectionRange(0, 0);
    },
    /**
     * @param {KeyboardEvent} e
     */
    end(e) {
      e.stopPropagation();
      e.preventDefault();
      e.target.setSelectionRange(e.target.value.length, e.target.value.length);
    },
    esc() {
      if (!this.showSuggestions && this.query.length !== 0) {
        this.query = '';
      }
      this.toggleShowSuggestions(false);
    },
    onSelect() {
      if (this.currentActiveIndex === -1) {
        this.$emit('query-set', this.query);
        return;
      }
      let item = this.suggestions[this.currentActiveIndex];
      let url = item.url;
      document.location.href = url;
    },
    reset() {
      this.currentActiveIndex = -1;
      this.showSuggestions = false;
    },
    update() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      if (this.query.length < this.minChars) {
        this.suggestions = [];
        return;
      }
      this.timeout = setTimeout(async () => {
        let propFilters = [];
        if (this.$props.filter != null) {
          propFilters = this.$props.filter;
        }
        let filter = propFilters.map((x) => [x.form_name, x.value]);
        filter.push(['q', this.query]);
        const query = new URLSearchParams(filter).toString();
        const response = await fetch('/de-de/search/rezepte?' + query, {
          method: 'GET',
        });
        const data = await response.json();
        const queryRegex = new RegExp(this.query, 'gi');
        this.items = data.result.map((item) => mapSearchResponseToItem(item, queryRegex));

        this.suggestions = this.items.slice(0, this.limit);
        this.showSuggestions = this.suggestions.length > 0;
      }, 500);
    },
    toggleShowSuggestions(isVisible) {
      this.showSuggestions = isVisible;
      if (!isVisible) {
        this.currentActiveIndex = -1;
      }
    },
    classShowSuggestions() {
      if (this.showSuggestions) {
        return 'isVisible';
      }
    },
    ariaActiveDescendant() {
      if (!this.showSuggestions) {
        return '';
      }

      if (this.currentActiveIndex === -1) {
        return '';
      }

      return this.items[this.currentActiveIndex].id;
    },
    ariaExpanded() {
      return this.showSuggestions ? 'true' : '';
    }
  },
});

app.component('recipe-teaser', {
  template: '#recipe-teaser',
  props: ['recipe', 'searchQuery'],
  created() {
    //console.log(this.$props.recipe)
  },
  data() {
    return {
      dietIcons: {
        Vegetarisch: 'diet-vegetarian',
        Laktosefrei: 'diet-lactosefree',
        Vegan: 'diet-vegan',
      },
    };
  },
  computed: {
    diets() {
      return this.$props.recipe.diets.map((x) => this.$data.dietIcons[x]);
    },
    windowUrlDEDE() {
      let url = window.location.href;
      return url.includes('/de-de/');
    },
  },
});

app.mount('#recipe-overview-app');
